import request from "@/api/request";

// --转换FormData
export function convertToFormData(obj) {
  const formData = new FormData();
  Object.keys(obj).forEach((key) => {
    formData.append(key, obj[key]);
  });
  return formData;
}
/**
 * 上传文件
 * @param {Number} MID 当前菜单ID
 * @param {String} instanceID 实例对像ID
 * @param {Function} callback callback 回调方法
 */
export async function PostFile(postData, file) {
  const data = convertToFormData({
    ...postData,
    file,
  });
  return PostUploadFile(data);
}

// 图片上传  PostUploadFileUrl
export function PostUploadFile(data) {
  return request({
    url: "/SystemData/UploadFile",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
    method: "post",
    data,
  });
}
